export default __webpack_public_path__ + "img/devops-eight-infinity.ba0dafad.jpg";